/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JobResponse,
    JobResponseFromJSON,
    JobResponseFromJSONTyped,
    JobResponseToJSON,
} from './JobResponse';

/**
 * 
 * @export
 * @interface JobsResponse
 */
export interface JobsResponse {
    /**
     * 
     * @type {Array<JobResponse>}
     * @memberof JobsResponse
     */
    elements: Array<JobResponse>;
    /**
     * 
     * @type {number}
     * @memberof JobsResponse
     */
    totalElementCount: number | null;
}

export function JobsResponseFromJSON(json: any): JobsResponse {
    return JobsResponseFromJSONTyped(json, false);
}

export function JobsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(JobResponseFromJSON)),
        'totalElementCount': json['totalElementCount'],
    };
}

export function JobsResponseToJSON(value?: JobsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(JobResponseToJSON)),
        'totalElementCount': value.totalElementCount,
    };
}

